import { Popover, PopoverIcon } from '../Popover'
import { Typography } from 'ui/typography'
import { Box } from 'ui/primitives'

export type Variant = 'dark' | 'light'

interface Props {
	label?: string
	variant?: Variant
	children: React.ReactNode
}

export const Tooltip = ({ label, variant = 'dark', children }: Props) => {
	return (
		<Popover>
			<Popover.Trigger>
				<Box color={variant === 'dark' ? 'neutral.dark' : 'common.white'}>
					<Typography>{label}</Typography> <PopoverIcon />
				</Box>
			</Popover.Trigger>
			<Popover.Content>{children}</Popover.Content>
		</Popover>
	)
}
